import { Role, WorkspaceRoleId } from "../../../../state/types";

export type RoleOption = { text: string; value: WorkspaceRoleId };

type BaseRoleOption = { text: string; value: Role };

export const DEFAULT_BASE_ROLE_OPTIONS: BaseRoleOption[] = [
    { text: "Admin", value: "owner" },
    { text: "Labeler", value: "labeler" },
    { text: "Reviewer", value: "reviewer" }
];
